import React, { SVGProps } from "react";

const SvgCustomGroups = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlSpace="preserve"
    width="1em"
    height="1em"
    className="svg-icon"
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9569 10.0152C14.9569 11.5925 14.2459 12.2456 13.5033 12.9277C12.4369 13.9073 13.3568 15.248 14.8049 15.248H16.0782C16.8383 15.248 17.4545 15.8643 17.4545 16.6244V17.9989H16.08H7.82568H6.45117V16.6244C6.45117 15.8643 7.06738 15.248 7.8275 15.248H9.13445C10.5825 15.248 11.5024 13.9073 10.436 12.9277C9.69339 12.2456 8.98242 11.5925 8.98242 10.0152C8.98242 7.116 10.3199 6.00195 11.9697 6.00195C13.6195 6.00195 14.9569 7.116 14.9569 10.0152ZM5.95117 17.9994V16.9017C5.95117 16.486 6.08634 16.1019 6.31513 15.791C5.37171 15.61 4.86038 14.6822 5.6191 13.9853C6.20683 13.4454 6.76952 12.9286 6.76952 11.6802C6.76952 9.38562 5.71101 8.50391 4.40527 8.50391C3.09953 8.50391 2.04102 9.38562 2.04102 11.6802C2.04102 12.9286 2.60371 13.4454 3.19143 13.9853C4.01471 14.7415 3.34262 15.7696 2.24575 15.8203H1.12641C0.524803 15.8203 0.0371094 16.308 0.0371094 16.9096V16.9116V17.9975H1.05923C1.08098 17.9988 1.10289 17.9994 1.12497 17.9994H5.95117ZM17.9545 16.9017V17.9994H22.8766C22.8908 17.9994 22.9049 17.9991 22.9189 17.9986C22.9268 17.9983 22.9346 17.9979 22.9423 17.9975H23.9645V16.9116V16.9096C23.9645 16.308 23.4768 15.8203 22.8752 15.8203H21.7835C20.6867 15.7696 20.0146 14.7415 20.8379 13.9853C21.4256 13.4454 21.9883 12.9286 21.9883 11.6802C21.9883 9.38562 20.9298 8.50391 19.624 8.50391C18.3183 8.50391 17.2598 9.38562 17.2598 11.6802C17.2598 12.9286 17.8225 13.4454 18.4102 13.9853C19.1981 14.709 18.6163 15.6818 17.6033 15.8085C17.8244 16.1163 17.9545 16.4938 17.9545 16.9017Z"
      fill="#4B4B4B"
    />
  </svg>
);

export default SvgCustomGroups;
